<template>
  <BaseDrawer>
    <template #trigger>
      <button
        class="flex w-full cursor-pointer items-stretch justify-between overflow-hidden rounded-lg text-gray-400 hover:bg-white"
      >
        <div class="p-1">
          <BaseIcon name="question" class="mb-0.5 text-lg" />
          Zo werkt deze pagina
        </div>
      </button>
    </template>
    <template #content>
      <TextDrawerTitle class="border-b border-gray-100 p-4 md:p-6">
        <BaseIcon name="question" filled class="mb-1" />
        Zo werkt deze pagina
      </TextDrawerTitle>
      <div class="flex flex-col gap-3 p-4 text-base font-normal md:p-6">
        <p>
          De Energierekening geeft op een overzichtelijke manier inzicht in jouw
          energierekening per maand. Je ziet hoe jouw factuur is opgebouwd en
          welke gegevens hieraan ten grondslag liggen.
        </p>
        <p>
          Wil je meer details bekijken? Dan kun je de onderliggende data tot op
          kwartierniveau inzien. Maandelijkse bedragen zelf zijn niet zichtbaar
          op kwartierniveau, omdat deze zijn gebaseerd op totalen over de hele
          maand.
        </p>
        <p>Deze pagina vormt daarmee de onderbouwing van jouw factuur.</p>
        <p>Onderaan deze pagina kun je eenvoudig alle gegevens exporteren.</p>
      </div>
    </template>
  </BaseDrawer>
</template>

<script setup>
import {
  BaseDrawer,
  BaseIcon,
  TextDrawerTitle,
} from "@repowerednl/ui-component-library"
</script>
